import { useSyncExternalStoreWithSelector } from "use-sync-external-store/shim/with-selector";
import {
  featureFlagsStore,
  type FeatureFlagsStoreState,
} from "src/stores/feature-flags/feature-flags.store";

export function useFeatureFlagsStore<T>(
  selector: (state: FeatureFlagsStoreState) => T,
  isEqual: (a: T, b: T) => boolean = Object.is
): T {
  return useSyncExternalStoreWithSelector(
    featureFlagsStore.subscribe,
    featureFlagsStore.getSnapshot,
    featureFlagsStore.getServerSnapshot,
    selector,
    isEqual
  );
}

const selectIsResolved = (state: FeatureFlagsStoreState) => state.isResolved;

export function useAreFeatureFlagsResolved(): boolean {
  return useFeatureFlagsStore(selectIsResolved);
}
